import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './SidePanel.st.css.js';
import Header from './Header';
import Content from './Content';
import Footer from './Footer';
import Divider from './Divider';
import { SidePanelContext } from './SidePanelAPI';
class SidePanel extends React.PureComponent {
    render() {
        const { dataHook, children, className, width, onCloseButtonClick } = this.props;
        return (React.createElement(SidePanelContext.Provider, { value: { onCloseButtonClick } },
            React.createElement("div", { className: st(classes.root, className), "data-hook": dataHook, style: { width } }, children)));
    }
}
SidePanel.displayName = 'SidePanel';
SidePanel.propTypes = {
    /** Applies a CSS class to the component’s root element */
    className: PropTypes.string,
    /** Applies a data-hook HTML attribute to be used in the tests */
    dataHook: PropTypes.string,
    /** Defines a callback function which is called every time a close button is clicked.
     */
    onCloseButtonClick: PropTypes.func,
    /** Accepts any item as a child element. For standard panel layout pass compound elements of the panel:
     * * `<SidePanel.Header/>`
     * * `<SidePanel.Content/>`
     * * `<SidePanel.Footer/>`
     * * `<SidePanel.Divider/>`
     */
    children: PropTypes.node,
    /** Controls the width of the panel */
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
SidePanel.defaultProps = {
    width: '420px',
};
SidePanel.Header = Header;
SidePanel.Content = Content;
SidePanel.Footer = Footer;
SidePanel.Divider = Divider;
export default SidePanel;
//# sourceMappingURL=SidePanel.js.map